import * as React from "react";
const SvgDashedLine = (props) => /* @__PURE__ */ React.createElement("svg", { width: 25, height: 25, viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0.5 12.6367H24.5", stroke: "#B5B6B7", strokeLinecap: "round", strokeDasharray: "4 4" }));
export default SvgDashedLine;
